import React, { Fragment, useEffect, useState } from 'react';
import { getIGSTDataService } from '../../../services/IGSTReportService';
import { getReportSummaryData, getAllAdminIECsService } from '../../../services/FileDataService';
import { Table, Button, DatePicker, message, Input, Select } from 'antd';
import { Col, Row } from 'react-bootstrap';
import { Excel } from 'antd-table-saveas-excel';
import Card from '../../../components/bootstrap/card';
import { getTodaysDate, formatToTwoDecimals } from '../../../utilities/utils';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import dayjs from 'dayjs';
import { getBRCorelationService } from '../../../services/MasterService';
import { useLocation } from 'react-router-dom';
import ReportDateFilter from '../../../components/ReportDateFilter';

import useColumnVisibility from '../../../hooks/useColumnVisibility';
import ColumnSelector from '../../../components/common/ColumnSelector';

const { RangePicker } = DatePicker;
const IGSTReport = ({ data }) => {
    const location = useLocation();
    const [IECOptions, setIECOptions] = useState([]);
    const userRole = localStorage.getItem('role'); 
    const [selectedIEC, setSelectedIEC] = useState(
      localStorage.getItem('iec_no')
    );
    const [jsonData, setJsonData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoading2, setIsLoading2] = useState(false);
    const [summaryDashboardData, setSummaryDashboardData] = useState([]);
    const today = new Date();
    // Extract day, month, and year components
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const year = today.getFullYear();
    const [selectedIECName, setSelectedIECName] = useState(localStorage.getItem('name'))
    const [isValid, setIsValid] = useState(true); // Validation state
    const [billNo, setBillNo] = useState("");

  const currentYear = dayjs().year();
  const defaultFrom = dayjs(`${currentYear}-01-01`);
  const defaultTo = dayjs(`${currentYear}-12-31`);
  const [dates, setDates] = useState(() => {
       // if report is opened through navigation from dashboard, then use those dates else default
     if (location.state?.passedDates?.length === 2) {
       return [
         dayjs(location.state.passedDates[0]),
         dayjs(location.state.passedDates[1]),
       ];
     }
     return [defaultFrom, defaultTo];
   });
  const [selectedBranchCodes, setSelectedBranchCodes] = useState([]);
  const [branchCodeNames, setBranchCodeNames] = useState([]);

  // Concatenate components with hyphens
  const formattedDate = `${day}-${month}-${year}`;

  // ─── TABLE STYLES ────────────────────────────────────────────────────────────
  const tableStyles = `
    .igst-table .ant-table-thead > tr > th,
    .igst-summary-table .ant-table-thead > tr > th {
      white-space: normal !important;
      word-break: break-word !important;
      overflow: visible !important;
      text-overflow: unset !important;
      vertical-align: middle !important;
      line-height: 1.3 !important;
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }
    .igst-table .ant-table-tbody > tr > td,
    .igst-summary-table .ant-table-tbody > tr > td {
      white-space: nowrap;
    }
    .igst-table .ant-table-container,
    .igst-summary-table .ant-table-container {
      overflow-x: auto !important;
    }
    .igst-table .ant-table-header,
    .igst-summary-table .ant-table-header {
      overflow: hidden !important;
    }
    .igst-table .ant-table-sticky-holder,
    .igst-summary-table .ant-table-sticky-holder {
      overflow: hidden !important;
    }
  `;

  // ─── COLUMN DEFINITIONS ────────────────────────────────────────────────────────
  // Widths: (header char count * 9) + 32
  // Define columns for the table
  const columns = [
    {
      title: 'BUSINESS UNIT',
      dataIndex: 'business_unit',
      key: 'business_unit',
      header: 'BUSINESS UNIT',
      width: 160
    , fixed: 'left' },
    {
      title: 'PLANT NAME',
      dataIndex: 'plant_name',
      key: 'plant_name',
      header: 'PLANT NAME',
      width: 150
    , fixed: 'left' },
    {
      title: 'IEC/Br CODE',
      dataIndex: 'iec_br',
      key: 'iec_br',
      header: 'IEC/Br CODE',
      width: 150
    },
    {
      title: 'PORT',
      dataIndex: 'port_code',
      key: 'port_code',
      header: 'PORT',
      width: 90
    },
    {
      title: 'FY',
      dataIndex: 'fy',
      key: 'fy',
      header: 'FY',
      width: 80
    },
    {
      title: 'SHB NO.',
      dataIndex: 'sb_no',
      key: 'sb_no',
      header: 'SHB NO.',
      width: 115
    },
    {
      title: 'SHB DT.',
      dataIndex: 'sb_date',
      key: 'sb_date',
      header: 'SHB DT.',
      width: 115
    },
    {
      title: 'LEO DT.',
      dataIndex: 'leo_date',
      key: 'leo_date',
      header: 'LEO DT.',
      width: 115,
      render: (text, record) => formatDateToDDMMYY(record.leo_date)
    },
    {
      title: 'IGST AMT. (INR)',
      dataIndex: 'igst_amt',
      key: 'igst_amt',
      header: 'IGST AMT. (INR)',
      align: 'right',
      width: 165,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    {
      title: 'SCROLL NO. / QUERY',
      dataIndex: 'igst_scroll_number',
      key: 'igst_scroll_number',
      header: 'SCROLL NO. / QUERY',
      width: 195
    },
    {
      title: 'SCROLL DT.',
      dataIndex: 'igst_scroll_date',
      key: 'igst_scroll_date',
      header: 'SCROLL DT.',
      width: 130,
      render: (text, record) => {
        if (record.igst_scroll_date) {
          return formatDateToDDMMYY(record.igst_scroll_date);
        }
      }
    },
    {
      title: 'SCROLL AMT.',
      dataIndex: 'scroll_amount',
      key: 'scroll_amount',
      header: 'SCROLL AMT.',
      align: 'right',
      width: 140,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    {
      title: 'IGST REMARK',
      dataIndex: 'igst_remark',
      key: 'igst_remark',
      header: 'IGST REMARK',
      width: 150
    },
    {
      title: 'SCROLL TAT',
      dataIndex: 'scroll_tat',
      key: 'scroll_tat',
      header: 'SCROLL TAT',
      align: 'right',
      width: 130
    },
    {
      title: 'EGM No',
      dataIndex: 'egm_no',
      key: 'egm_no',
      header: 'EGM No',
      width: 130
    },
    {
      title: 'EGM Dtd.',
      dataIndex: 'egm_date',
      key: 'egm_date',
      header: 'EGM Dtd.',
      width: 120,
      render: (text, record) => record.egm_date ? formatDateToDDMMYY(record.egm_date) : ''
    },
    {
      title: 'EGM Remarks',
      dataIndex: 'egm_remarks',
      key: 'egm_remarks',
      header: 'EGM Remarks',
      width: 140
    }
  ];

  const { visibleKeys, setVisibleKeys, filteredColumns, resetToDefault } =
    useColumnVisibility('IGSTReport', columns);

  const dashboardReportSummaryColumns = [
    {
      title: 'BUSINESS UNIT',
      dataIndex: 'business_unit',
      key: 'business_unit',
      header: 'BUSINESS UNIT',
      width: 160
    , fixed: 'left' },
    {
      title: 'PLANT NAME',
      dataIndex: 'plant_name',
      key: 'plant_name',
      header: 'PLANT NAME',
      width: 150
    , fixed: 'left' },
    {
      title: 'FY',
      dataIndex: 'fy',
      key: 'fy',
      header: 'FY',
      width: 80
    },
    {
      title: 'IEC/BR CODE',
      dataIndex: 'iec_br',
      key: 'iec_br',
      header: 'IEC/BR CODE',
      width: 150
    },
    {
      title: 'PORT CODE',
      dataIndex: 'port_code',
      key: 'port_code',
      header: 'PORT CODE',
      width: 115
    },
    {
      title: 'IGST REFUND AMT.',
      dataIndex: 'igst_refund_amt',
      key: 'igst_refund_amt',
      header: 'IGST REFUND AMT.',
      align: 'right',
      width: 185,
      render: (text, record) => {
        return formatToTwoDecimals(text)
      }
    },
    {
      title: 'IGST REMARK',
      dataIndex: 'igst_remark',
      key: 'igst_remark',
      header: 'IGST REMARK',
      width: 150,
      render: (text, record) => (
        <span
          style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => exportToExcel(text, record)}
        >
          {text}
        </span>
      ),
    },
    {
      title: 'NO. OF SHB',
      dataIndex: 'remark_count',
      key: 'remark_count',
      header: 'NO. OF SHB',
      align: 'right',
      width: 130
    }
  ];


  const getSummaryDashboard = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null,
      bill_no: billNo.trim() || null,
      br_code: selectedBranchCodes || null,
    };
    try{
        setIsLoading2(true)
        let reportType = 'IGST-Refund'
        const response = await getReportSummaryData(reportType, filters, selectedIEC);

      if (response) {
        console.log("response: ", response.data);
        if (response.data) {
          setSummaryDashboardData(response.data);
        }
      }
      else {
        console.log("getSummaryDashboard :: no reponse")
        setSummaryDashboardData([]);
      }
      setIsLoading2(false)
    }
    catch (err) {
      setIsLoading2(false)
      console.log(err);
    }
  }

  function formatDateToDDMMYY(dateString) {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return ''; // Return empty string if the dateString is not a valid date
    }
    else {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = String(date.getFullYear()).slice(-2);
      return `${day}/${month}/${year}`;
    }
  }

  const getDateOnly = (dateString) => {
    if (dateString && dateString.length !== 0) {
      const date = new Date(dateString);
      return date;
    }
    else {
      return '';
    }
  }

  const handleDateChange = (value) => {
    setDates(value || []);
    if (value && value.length === 2) {
      const from_date = value[0];
      const to_date = value[1];

      // Validate that both dates are selected
      if (!from_date || !to_date) {
        setIsValid(false);
        return;
      }

      // Validate that the duration is within 1 year
      const oneYearLater = from_date.add(1, 'year');
      if (to_date.isAfter(oneYearLater)) {
        message.error("The selected duration should not exceed 1 year.");
        setIsValid(false);
        return;
      }

      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const handleSubmit = () => {
    if (!selectedIEC) {
        message.error("Please select an IEC");
        return;
      }
    if (dates.length === 2 && isValid){
      getSummaryDashboard();
      fetchData();
    }
    else {
      message.error("Please select a valid date range.");
    }
  };

  const getAdminIEC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await getAllAdminIECsService(token);

      if (response?.data) {
        const options = response.data.map((item, index) => ({
          value: `${item.iec_no};${item.fullname}`,
          label: `${item.iec_no} (${item.fullname})`,
          key: index,
        }));
        setIECOptions(options);
      }
    } catch (err) {
      message.error("Failed to load IEC list");
    }
  };

const handleIECSelection = (val) => {
  if (val) {
    const [iec_no, iec_name] = val.split(";");
    setSelectedIEC(iec_no);
    setSelectedIECName(iec_name);
  } else {
    setSelectedIEC(null);
    setSelectedIECName('');
  }
};



  const handleBillSearch = (value) => {
    setBillNo(value);
  };
  const handleBranchCodeSelection = (values) => {
    setSelectedBranchCodes(values);
  };
  const exportToExcel = async (filterRemark = null, record = null) => {
    let workbook = new ExcelJS.Workbook();
    let summaryWorksheet = workbook.addWorksheet('Summary');
    let worksheet = workbook.addWorksheet('Data');
    let data = jsonData;
    let summaryData = summaryDashboardData;

    // Apply filter if remark is clicked
    if (record) {
      const ignoreKeys = ['remark_count', 'igst_refund_amt'];
      const isMatch = (item, searchRecord) => {
        for (let key in searchRecord) {
          if (key === 'key' || ignoreKeys.includes(key)) continue;
          if (item.hasOwnProperty(key)) {
            if (item[key] !== searchRecord[key]) {
              return false;
            }
          }
        }
        return true;
      };

      data = data.filter(item => isMatch(item, record));
      summaryData = summaryData.filter(item => isMatch(item, record));
    } else if (filterRemark && typeof filterRemark === 'string') {
      data = data.filter(item => item.igst_remark === filterRemark);
      summaryData = summaryData.filter(item => item.igst_remark === filterRemark);
    }

    // Define columns for Excel export
    summaryWorksheet.columns = filteredSummaryColumns.map(col => ({
      header: col.header || col.title,
      key: col.dataIndex,
      width: 20
    }));
    // Apply styles to the header row (Row 1)
    summaryWorksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true }; // Bold text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC000' }, // Yellow background
      };
      cell.alignment = { vertical: 'middle' }; // Center align
    });

    summaryData.forEach((obj) => {
      summaryWorksheet.addRow({
        ...obj
      })
    })

    worksheet.columns = filteredColumns.map(col => ({
      header: col.header || col.title,
      key: col.dataIndex,
      width: 20
    }));
    // Apply styles to the header row (Row 1)
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true }; // Bold text
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC000' }, // Yellow background
      };
      cell.alignment = { vertical: 'middle' }; // Center align
    });

    data.forEach((obj) => {
      worksheet.addRow({
        ...obj,
        sb_date: getDateOnly(obj.sb_date),
        leo_date: getDateOnly(obj.leo_date),
        igst_scroll_date: getDateOnly(obj.igst_scroll_date),
        egm_date: getDateOnly(obj.egm_date),
        igst_amt: obj.igst_amt ? parseFloat(obj.igst_amt) : '',
        scroll_amount: obj.scroll_amount ? parseFloat(obj.scroll_amount) : ''
      })

    });

    // Generate Excel file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // Use FileSaver to save the file
    const fileNameSuffix = filterRemark && typeof filterRemark === 'string' ? `_${filterRemark}` : '';
    saveAs(blob, `Lucrative's CIP DSS - IGST Refund as on ${getTodaysDate()} of ${selectedIEC}${fileNameSuffix}.xlsx`);
  };

  const preprocessData = (data) => {
    return data.map(record => {

      if (record.sb_date) {
        const sbDate = new Date(record.sb_date);
        record.sb_date = formatDateToDDMMYY(sbDate);
      }
      return record;
    });
  };

  const fetchData = async () => {
    const filters = {
      from_date: dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null,
      to_date: dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null,
      bill_no: billNo || null,
      br_code: selectedBranchCodes || null,
    };

    try {
      setIsLoading(true);
      const response = await getIGSTDataService(selectedIEC, filters);
      setJsonData(response);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching data:', error);
    }
  };


  useEffect(() => {
    if (userRole === 'superadmin' || userRole === 'group_head') {
      getAdminIEC();
    }
    if (userRole === 'admin' || userRole === 'user') {
      fetchData();
      getSummaryDashboard();
    }
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response || []);
      });
    }
  }, []);

  useEffect(() => {
    if (selectedIEC) {
      getBRCorelationService(selectedIEC).then((response) => {
        setBranchCodeNames(response || []);
      });
    } else {
      setBranchCodeNames([]);
    }
  }, [selectedIEC]);

  const filteredSummaryColumns = dashboardReportSummaryColumns.filter((col) => {
    const key = String(col.dataIndex || col.key);
    const isDefinedInDetail = columns.some((c) => String(c.dataIndex || c.key) === key);
    return isDefinedInDetail ? visibleKeys.includes(key) : true;
  });

  return (
    <Fragment>
      <style>{tableStyles}</style>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">Lucrative's CIP DSS  - IGST Refund as on {formattedDate} of {selectedIECName}</h4>
              </div>
              <div className="d-flex align-items-center gap-2">
                <ColumnSelector
                  allColumns={columns}
                  visibleKeys={visibleKeys}
                  setVisibleKeys={setVisibleKeys}
                  onReset={resetToDefault}
                />
                <button
                  className='btn btn-primary cip-btn-submit'
                  onClick={exportToExcel}
                >
                  Export to Excel
                </button>
              </div>
            </Card.Header>
            <Card.Body className="d-flex justify-content-start align-items-center gap-2 ps-4">
              {(userRole === 'superadmin' || userRole === 'group_head') && (
                <Select
                  showSearch
                  placeholder="Select IEC"
                  onChange={handleIECSelection}
                  allowClear
                  options={IECOptions}
                  style={{ width: '300px' }}
                />
              )}
              <ReportDateFilter dates={dates} onChange={handleDateChange} />
              <Input
                placeholder="Enter Bill No"
                allowClear
                value={billNo}
                onChange={(e) => handleBillSearch(e.target.value)}
                style={{ width: 250 }}
              />
              <Select
                mode="multiple"
                allowClear
                style={{ width: 250 }}
                placeholder="Select Branch Code"
                onChange={handleBranchCodeSelection}
                options={branchCodeNames.map((item) => ({
                  value: item.branch_code,
                  label: `${item.branch_code} / ${item.plant_name} (${item.business_unit})`,
                }))}
              />
              <Button type="primary" className="cip-btn-submit"
                onClick={handleSubmit}>
                Submit
              </Button>
            </Card.Body>
            <Card.Body className="px-0 report-page">
              <Table
                className="igst-summary-table"
                columns={filteredSummaryColumns}
                dataSource={summaryDashboardData}
                pagination={false}
                loading={isLoading2}
                bordered
                scroll={{ x: 'max-content' }}
                
              />
              <hr />
              <Table
                className="igst-table"
                bordered
                columns={filteredColumns}
                dataSource={jsonData}
                loading={isLoading}
                pagination={{ showTotal: (total) => `Total ${total} records`, showSizeChanger: true }}
                scroll={{ x: 'max-content' }}
                
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default IGSTReport;
